import React, { useCallback, useState } from 'react';
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Grid,
    CircularProgress
} from '@material-ui/core';
import { DeleteIcon, EditIcon } from '../../../icons';
import ActionIconButton from '../../../components/atom/ActionIconButton';

import TablePager from '../../../components/atom/TablePager';
import { MODAL_TYPE, useModals } from '../../../hooks/useModal';
import { useNotify } from '../../../hooks/useNotify';
import { doSwaggerCall, useSwaggerClient } from '../../../hooks/useSwaggerClient';
import AdminHeader from '../../../components/atom/AdminHeader';

function IslandsListPage() {
    const [search, setSearch] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(0);
    const { showModal } = useModals();
    const { notifyError, notifySuccess } = useNotify();

    const [data, loading, error, setData, reloadChains] = useSwaggerClient(
        'islands',
        'getAllIslands',
        {
            page,
            pageSize,
            search
        }
    );

    const deleteIsland = useCallback(
        islandId => {
            doSwaggerCall('islands', 'deleteIsland', { islandId })
                .then(() => {
                    // we finished, remove user from list
                    notifySuccess('Region deleted!');
                    reloadChains();
                })
                .catch(() => {
                    notifyError('Cannot delete region!');
                });
        },
        [setData, data, notifyError, notifySuccess]
    );

    if (error) {
        return (
            <Grid container justifyContent="center">
                <h1>{error}</h1>
            </Grid>
        );
    }

    return (
        <Grid container className="bg-white client-table page" alignItems="center" spacing={2}>
            <AdminHeader
                title="Regions"
                search={search}
                onSearch={newSearch => {
                    setPage(0);
                    setSearch(newSearch);
                }}
                createLabel="New region"
                onCreate={() => {
                    showModal(MODAL_TYPE.CREATE_ISLAND);
                }}
            />
            <Grid item container xs={12} justifyContent="center">
                {loading && data?.islands.length === 0 ? (
                    <CircularProgress />
                ) : (
                    <Table style={{ backgroundColor: 'white' }} size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>VAT</TableCell>
                                <TableCell>Timezone</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data &&
                                data.islands &&
                                data.islands.map(island => (
                                    <TableRow key={island.id}>
                                        <TableCell>{island.name}</TableCell>
                                        <TableCell>{island.vat} %</TableCell>
                                        <TableCell>{island.timezone}</TableCell>
                                        <TableCell style={{ width: 100 }}>
                                            <ActionIconButton
                                                title="Edit"
                                                icon={EditIcon}
                                                to={`/admin/regions/update/${island.id}`}
                                            />
                                            <ActionIconButton
                                                title="Delete"
                                                icon={DeleteIcon}
                                                onClick={() => {
                                                    showModal(MODAL_TYPE.CONFIRMATION, {
                                                        title: `Are you sure you want to remove ${island?.name}?`,
                                                        content: 'This action is irreversible.',
                                                        confirm: () => deleteIsland(island.id)
                                                    });
                                                }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                )}
                <Grid container justifyContent="flex-end">
                    <TablePager
                        total={data?.total}
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}

export default IslandsListPage;
